import React from 'react';
import { Mail } from 'lucide-react';
import { useZimbraSaaS } from '../../../hooks/saas/useZimbraSaaS';
import SaaSProduct from './SaaSProduct';

const ZimbraSaaS = () => {
  const { getTranslation } = useZimbraSaaS();
  const translation = getTranslation();

  return (
    <SaaSProduct
      icon={Mail}
      title={translation.title}
      description={translation.description}
      tiers={translation.tiers}
    />
  );
};

export default ZimbraSaaS;